module.exports = __webpack_public_path__ + "img/technology-02.f98dbef5.png";